import { buildTouchpointEditorRegistry, resolveTouchpointEditorId } from './touchpointEditorResolve.js';

const modules = import.meta.glob('./*.vue');
const registry = buildTouchpointEditorRegistry(modules);

/** Loader `() => import(...)` for the channel editor, or null when none is registered. */
export function loadTouchpointEditor(channel) {
    const id = resolveTouchpointEditorId(channel);
    return registry[id] || null;
}

export { resolveTouchpointEditorId };
